import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import ET3Div from "../et3-div";
import Lottie from "react-lottie-player";
import * as animationData from "../et3-loading/et3-loading.json";
import getCoreUIStore from "../../stores/core/core-ui-store";

const Et3Loading = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const shouldShow = getCoreUIStore().isAdminLoading.get();

  return shouldShow ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={true}
      width={2000}
      height={1080}
      color={colors.all.transparentGray}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <Lottie
        loop
        animationData={animationData}
        play
        style={{
          width: 446 * unitX,
          height: 352 * unitY,
          color: colors.all.bluishGreenish
        }}
      />
    </ET3Div>
  ) : null;
});
export default Et3Loading;
